document.addEventListener("DOMContentLoaded",()=>{const t=document.querySelector(".mobile-toggle"),m=document.querySelector(".mobile-menu");if(t&&m)t.addEventListener("click",()=>m.toggleAttribute("hidden"));});
document.addEventListener("DOMContentLoaded",function(){
  document.querySelectorAll("[data-announcement-bar]").forEach(function(bar){
    var items = bar.querySelectorAll(".announcement-item");
    if(items.length < 2) return;
    var i = 0;
    var speed = (parseInt(bar.dataset.speed,10) || 4) * 1000;
    setInterval(function(){
      items[i].classList.remove("active");
      i = (i + 1) % items.length;
      items[i].classList.add("active");
    }, speed);
  });
  document.querySelectorAll("[data-hero-slider]").forEach(function(hero){
    var track = hero.querySelector(".hero-slides");
    var slides = hero.querySelectorAll(".hero-slide");
    if(!track || slides.length < 2) return;
    var dots = hero.querySelectorAll(".hero-dot");
    var prevBtn = hero.querySelector(".hero-prev");
    var nextBtn = hero.querySelector(".hero-next");
    var total = slides.length;
    var index = 0;
    function goTo(i){
      index = (i + total) % total;
      track.style.transform = "translateX(-" + (index * 100) + "%)";
      dots.forEach(function(d, di){ d.classList.toggle("active", di === index); });
    }
    if(prevBtn) prevBtn.addEventListener("click", function(){ goTo(index - 1); });
    if(nextBtn) nextBtn.addEventListener("click", function(){ goTo(index + 1); });
    dots.forEach(function(d){
      d.addEventListener("click", function(){ goTo(parseInt(d.dataset.slideTo, 10)); });
    });
    var startX = null;
    track.addEventListener("touchstart", function(e){ startX = e.touches[0].clientX; }, {passive:true});
    track.addEventListener("touchend", function(e){
      if(startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if(Math.abs(dx) > 40){ dx < 0 ? goTo(index + 1) : goTo(index - 1); }
      startX = null;
    }, {passive:true});
  });
});
